import React, { useState } from "react";
import "./styles.css";

import { BsArrowCounterclockwise, BsArrowClockwise } from "react-icons/bs";
import { FaHighlighter } from "react-icons/fa";

const MenuFabric = props => {
  const [jsonData, setJsonData] = useState();
  const [pencilColor, setPencilColor] = useState();
  const [stroke, setStroke] = useState(1);
  const [inputColorPencil, setInputColorPencil] = useState("#000000");

  /* Função de navegar pelas alterações do fabric */
  const [mainStack, setMainStack] = useState([]);
  const [auxStack, setAuxStack] = useState([]);

  const onAddText = () => {
    props.editor.disablePencil();
    props.textFlag(prevState => !prevState);
    props.setCursorState(false);
    props.setActivePencil(false);
    props.setActiveRectangle(false);
    props.setDropdownPencil(false);
  };

  const onAddRectangle = () => {
    props.editor.disablePencil();
    props.rectFunctions.fill("#FFFF00");
    props.rectFunctions.opacity(0.1);
    props.rectFlag(prevState => !prevState);
    props.textFlag(false);
    props.setActivePencil(false);
    props.setActiveRectangle(true);
    props.setCursorState(false);
    props.setDropdownPencil(false);
  };

  const onEnablePencil = () => {
    props.editor.enablePencil();
    props.textFlag(false);
    props.setActivePencil(true);
    props.setCursorState(false);
    props.setActiveRectangle(false);
  };
  const onEnableHand = () => {
    props.editor.disablePencil();
    props.textFlag(false);
    props.setCursorState(true);
    props.setActivePencil(false);
    props.setActiveRectangle(false);
    props.setDropdownPencil(false);
  };
  const onDeleteSelected = () => {
    props.editor.deleteSelected();
    props.textFlag(false);
  };
  const onSave = () => {
    let jsonData = props.editor.saveJson();
    setJsonData(jsonData);
  };
  const onLoad = () => {
    props.editor.loadJson(jsonData);
  };

  const onZoomIn = () => {
    props.editor.zoomSet(1.1);
  };

  const onHeight = () => {
    props.setCanvasHeight(`${4 * 857 - 20}px`);
  };

  const onChangeWidth = () => {
    props.editor.setWidth(700);
  };

  const onBlue = () => {
    props.editor.setPencilColor("#00FFFF");
  };

  const onPencilWidth = () => {
    props.editor.setPencilWidth(2);
  };

  const onOpacity = () => {
    props.editor.setPencilColor("rgba(0, 0, 255, 0.3)");
  };

  const onDropdown = () => {
    props.setDropdownPencil(!props.showDropdownPencil);
    props.setCursorState(false);
    props.setActiveRectangle(false);
    props.textFlag(false);
    onEnablePencil();
  };

  const changeColorPecil = e => {
    setInputColorPencil(e.target.value);
    props.editor.setPencilColor(e.target.value);
  };

  const updateStroke = e => {
    setStroke(e.target.value);
    props.editor.setPencilWidth(e.target.value);
  };

  return (
    <>
      <div id="menuFabric">
        <i
          className={
            props.addTextEnabled
              ? "fa fa-font clickable ativado"
              : "fa fa-font clickable"
          }
          onClick={onAddText}
        />
        <i
          className={
            props.cursorState
              ? "fa fa-mouse-pointer clickable ativado"
              : "fa fa-mouse-pointer clickable"
          }
          onClick={onEnableHand}
        />

        <i
          className={
            props.activePencil
              ? "fa fa-pencil clickable ativado"
              : "fa fa-pencil clickable"
          }
          onClick={onEnablePencil}
        />
        <i
          className={
            props.showDropdownPencil
              ? "fa fa-angle-up clickable ativado"
              : "fa fa-angle-down clickable"
          }
          onClick={onDropdown}
          style={{ marginLeft: "-1px" }}
        />

        {/* <i
          className={
            props.activeRectangle
              ? "fa fa-square-o clickable ativado"
              : "fa fa-square-o clickable"
          }
          onClick={onAddRectangle}
        /> */}

        <FaHighlighter
          className={props.activeRectangle ? "brush ativado" : "brush"}
          onClick={onAddRectangle}
        />

        <i className="fa fa-trash clickable trash" onClick={onDeleteSelected} />

        <BsArrowCounterclockwise
          onClick={props.previousState}
          className="jsonnav spaceLeft"
        />
        <BsArrowClockwise onClick={props.nextState} className="jsonnav" />
      </div>
      <div
        className={
          props.showDropdownPencil
            ? "dropdownPencil activeDropdown"
            : "dropdownPencil"
        }
      >
        <div className="slideContainer">
          <input
            type="range"
            min={1}
            max={5}
            value={stroke}
            onChange={updateStroke}
          />
          <p>Tamanho: {stroke}</p>
          <hr />
          <div id="changeColor">
            <p>Cor:</p>
            <input
              type="color"
              id="favcolor"
              name="favcolor"
              value={inputColorPencil}
              onChange={changeColorPecil}
            ></input>
          </div>
        </div>
      </div>
    </>
  );
};

export default MenuFabric;
